import { Cta, Reveal } from "@/components/landing/Shared";
import { Results } from "@/components/landing/Results";

export const RealResults = () => (
  <>
    <Results />
    <section className="bg-[var(--blush)] px-5 pb-24 text-center sm:px-8 lg:pb-32" data-testid="section-quote">
      <Reveal className="mx-auto max-w-3xl">
        <blockquote className="font-display text-2xl font-light italic leading-snug text-[var(--ink)] sm:text-3xl" data-testid="harley-quote">
          "If you're reading this, maybe this is your reminder that you were made for more than just getting by. 💗 I know what it feels like to want a different life. If your heart is telling you it's time for a change, take that first step. You don't have to figure it all out alone — let's build something better together."
        </blockquote>
        <p className="mt-5 font-semibold text-[var(--mauve-dark)]">- Harley</p>
        <div className="mt-10"><Cta testId="results-cta-button" label="I need this - join now" href="#get-access" /></div>
      </Reveal>
    </section>
  </>
);
